import * as React from "react";
import Component from "../../AbstractComponent";
import Environment from "../../../Environment/Environment";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

declare global {
  interface Window { gapi: any; }
}

export class EmailAccountCreate extends Component {

  public ref: any;

  public state = {
    imapUser:  "",
    imapPassword:  "",
    imapHost: "",
    imapPort: "",
    imapTls: Number(true),
    errors: [],
    isSaving: false,
    providerName: "Custom",
    providerId: 255,
    auth_code: null,
    isFetching: false
  };

  constructor(public props) {
    super(props);

    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  public componentDidMount() {
    const _onInit = auth2 => {
      console.log("init OK", auth2)
    };
    const _onError = err => {
      console.log("error", err)
    };
    window.gapi.load("auth2", function() {
      window.gapi.auth2
        .init({
          client_id: Environment.get().clientId
        })
        .then(_onInit, _onError)
    })
  }

  public signInAuth2 = () => {
    if(window.gapi.auth2.getAuthInstance().currentUser){
      window.gapi.auth2.getAuthInstance().currentUser.listen( (user) => {
        const userName = user.w3.U3
        this.setState({
          imapUser: userName
        });
      })
    }

    window.gapi.auth2.getAuthInstance().grantOfflineAccess({
      scope: 'https://www.googleapis.com/auth/userinfo.profile ' +
          'https://www.googleapis.com/auth/userinfo.email ' +
          'https://mail.google.com/',
        }).then( user => {
      this.setState({
        auth_code: user.code
      });
    }) ;
  }

  public signOutAuth2 = () => {
      this.setState({
        auth_code: null
      });
  }

  public onCancel(): any {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  public onSave(): any {
    if (typeof this.props.onSave !== "undefined") {
      this.setState({
        isSaving: true,
        isFetching: true
      });
      if(this.state.providerName === 'Gmail' && !!this.state.auth_code){
        this.props.onSave.call(this, {
          googleAuthCode: this.state.auth_code,
          imapHost: this.state.imapHost,
          imapPort: parseInt(this.state.imapPort, 10),
          imapTls: Boolean(this.state.imapTls),
          providerId: this.state.providerId,
          imapUser: this.state.imapUser,
        });
      } else {
        this.props.onSave.call(this, {
          imapUser: this.state.imapUser,
          imapPassword: this.state.imapPassword,
          imapHost: this.state.imapHost,
          imapPort: parseInt(this.state.imapPort, 10),
          imapTls: Boolean(this.state.imapTls),
          providerId: this.state.providerId
        });
      }

    }
  }

  public changeProvider = (event) => {
    const provider = event.target.value;

    if (provider !== "Custom") {
      return this.setState({
        imapHost: this.props.globalTypes?.EmailProviders?.[provider]?.imapHost || "",
        imapPort: this.props.globalTypes?.EmailProviders?.[provider]?.imapPort || "",
        imapTls: Number(this.props.globalTypes?.EmailProviders?.[provider]?.imapTls) || Number(false),
        providerId: this.props.globalTypes?.EmailProviders?.[provider]?.id || 255,
        providerName: this.props.globalTypes?.EmailProviders?.[provider]?.label || ""
      });
    }
    return this.setState({
      providerName: this.props.globalTypes?.EmailProviders?.[provider]?.label
    });
  }


  public render() {
    return (
      <div className="grid-container">
        <DialogContent>
          <div className="grid-65">
            <Select
              className="form-element full-size form-input scroll-to-emailProvider correct-label-position"
              error={this.getErrorFor("emailProvider")}
              value={this.state.providerId}
              onChange={this.changeProvider}
              htmlFor="emailProvider"
              label={this.trans("email-provider")}
              name="emailProvider" 
              id="emailProvider"
            >
              {
                Object.keys(this.props.globalTypes?.EmailProviders || {}).map(provider => {
                  let providers =  this.props.globalTypes?.EmailProviders?.[provider]

                  if (!providers.label) {
                    return;
                  }

                  return (
                    <MenuItem value={providers.id} key={providers.id}>{providers.label}</MenuItem>
                  );
                })
              }
            </Select>
            {
              this.state.providerName !== "Gmail" && (
                <div>
                  <TextField
                    className="form-element full-size scroll-to-imapUser"
                    autoComplete="off"
                    type="text"
                    label={this.trans("imap-user")}
                    value={this.state.imapUser}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "imapUser")}
                    autoFocus={true}
                    variant="standard"
                    error={!!this.getErrorFor("imapUser")}
                  />
                  {!!this.getErrorFor("imapUser") && <div className="component-error-text">{this.getErrorFor("imapUser")}</div>}

                  <TextField
                    className="form-element full-size scroll-to-imapPassword"
                    autoComplete="off"
                    type="password"
                    label={this.trans("imap-password")}
                    value={this.state.imapPassword}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "imapPassword")}
                    variant="standard"
                    error={!!this.getErrorFor("imapPassword")}
                  />
                  {!!this.getErrorFor("imapPassword") && <div className="component-error-text">{this.getErrorFor("imapPassword")}</div>}
                </div>
              )}
            {
              this.state.providerName === "Custom" && (
                <div>
                  <TextField
                    className="form-element full-size scroll-to-imapHost"
                    autoComplete="off"
                    type="text"
                    label={this.trans("imap-host")}
                    value={this.state.imapHost}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "imapHost")}
                    variant="standard"
                    error={!!this.getErrorFor("imapHost")}
                  />
                  {!!this.getErrorFor("imapHost") && <div className="component-error-text">{this.getErrorFor("imapHost")}</div>}

                  <TextField
                    className="form-element full-size scroll-to-imapPort"
                    autoComplete="off"
                    type="text"
                    label={this.trans("imap-port")}
                    value={this.state.imapPort}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "imapPort")}
                    variant="standard"
                    error={!!this.getErrorFor("imapPort")}
                  />
                  {!!this.getErrorFor("imapPort") && <div className="component-error-text">{this.getErrorFor("imapPort")}</div>}

                  <Select
                    className="form-element full-size form-input scroll-to-ssl correct-label-position"
                    value={this.state.imapTls}
                    onChange={this.sync.bind(this, this.syncronizers.TLS)}
                    htmlFor="SSL"
                    label={this.trans("label-ssl")}
                    name="SSL" 
                    id="SSL"
                  >
                    <MenuItem value={Number(true)}>{this.trans("label-yes")}</MenuItem>
                    <MenuItem value={Number(false)}>{this.trans("label-no")}</MenuItem>
                  </Select>
                </div>
              )
            }
            {
              this.state.providerName === "Gmail" && (
                <div style={{display: "flex", alignItems: "center"}}>
                  { !this.state.auth_code &&
                    <Button
                      style={{marginTop: "10px"}}
                      color="primary"
                      variant="contained"
                      onClick={this.signInAuth2}
                    >
                      {this.trans("button-google-account-google-login")}
                    </Button>
                  }

                  { this.state.auth_code &&
                    <div style={{display: "flex", alignItems: "center"}}>
                      <Button
                        style={{marginTop: "10px"}}
                        color="primary"
                        variant="contained"
                        onClick={this.signOutAuth2}
                      >
                        {this.trans("button-google-account-google-logout")}
                      </Button>
                      <span
                        style={{margin: "10px 0 0 15px"}}
                      >
                        {this.state.imapUser}
                      </span>
                    </div>
                  }
                </div>
              )
            }
          </div>

          <div className="conection-result-wrapper" style={{marginTop: "10px"}}>
            <Card>
              <div>{this.trans("reason")}</div>
              {this.state.errors.map((message, index) => <p key={index}><b>{this.trans("logs")}</b> {message}</p>)}
            </Card>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="row">
            <div className="button-container" style={{marginTop: "5px"}}>
              <Button
                color="primary"
                onClick={this.onCancel}
              >
                {this.trans("button-cancel")}
              </Button>

              <Button
                disabled={(this.hasModifiedData() === false || this.state.isFetching === true) &&  !this.state.auth_code }
                color="primary"
                variant="contained"
                onClick={this.onSave}
              >
                {this.state.isFetching === true ? this.trans("button-creating") : this.trans("button-create")}
              </Button>
            </div>
          </div>
        </DialogActions>
      </div>
    );
  }
}
